module.exports = __webpack_public_path__ + "static/duergar_mind_master-7f181c152f66a3c613148e8f079993cd.png";